
import * as types from "../constants/action-types";

export default function menuReducer(state = {}, action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.LOAD_DISTANCE_SUCCESS:        
            return action.distance;      
        default:
            return state;
    };
};
